export default __webpack_public_path__ + "static/media/hht1_ep09_timeline_q01_a.5debda8a.png";